export default "__VITE_ASSET__bf829832__"